const commonIcons = {
  histroyUpIcon: '/images/common_icon/ic_change_history_up_enable_20dp.svg',
  histroyDownIcon: '/images/common_icon/ic_change_history_down_enable_20dp.svg',
  chartBarX: '/images/common_icon/ic_chart_stacked_black_24dp.svg',
  chartBarY: '/images/common_icon/ic_chart_stacked_full_black_24dp.svg',
  chartLine: '/images/common_icon/ic_chart_ssid_black_24dp.svg',
  xperIcon: '/images/common_icon/ic_token_xper_30dp.svg',
  perIcon: '/images/common_icon/ic_token_per_30dp.svg',
  hvhIcon: '/images/common_icon/ic_token_hvh_30dp.svg',
  usdtIcon: '/images/common_icon/ic_token_usdt_30dp.png',
  arbIcon: '/images/common_icon/ic_token_arb_30dp.svg',
  fiatIcon: '/images/common_icon/ic_token_fiatpp_30dp.svg',
  freeIcon: '/images/common_icon/ic_token_freepp_30dp.svg',
  infoIcon: '/images/common_icon/ic_info_circle_outline_gray_24dp.svg',
  powerIcon: '/images/common_icon/ic_power_30dp.svg',
  extraPowerIcon: '/images/common_icon/ic_extra_power_30dp.svg',
  filterIcon: '/images/common_icon/ic_filter_list_gray_24dp.svg',
  purpleChangeIcon: '/images/common_icon/ic_change_history_right_disable_purple_20dp.svg',
  onLineIcon: '/images/common_icon/ic_login_oneline_green_small.svg',
  offLineIcon: '/images/common_icon/ic_login_oneline_gray_small.svg',
  transferIcon: '/images/common_icon/ic_wallet_transfer_UD_24dp.svg',
  warningIcon: '⚠️',
  alertIcon: '❗️',
  equalGrade: '/images/common_icon/tagui=equal.svg',
  moreGrade: '/images/common_icon/tagui=more.svg',
};

export default commonIcons;
